export default __webpack_public_path__ + "static/media/proposal-tab-icon.15581210.svg";